// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tripApprovalEntity from './entities/trip-approval.json';
import tripApprovalMenu from '../pages/trip-approval/menu.json';
import tripApprovalFullForm from '../pages/trip-approval/forms/full.json';
import tripApprovalContextForm from '../pages/trip-approval/forms/context.json';
import tripApprovalMiniForm from '../pages/trip-approval/forms/mini.json';
import tripApprovalLookupForm from '../pages/trip-approval/forms/lookup.json';
import tripApprovalTableView from '../pages/trip-approval/views/table.json';
import tripApprovalCardsView from '../pages/trip-approval/views/cards.json';
import tripApprovalCalendarView from '../pages/trip-approval/views/calendar.json';
import tripApprovalDashboardView from '../pages/trip-approval/views/dashboard.json';

/** Тип запису «Погодження поїздки» зі сторінками пакета: меню, форми та подання з pages/trip-approval/. */
export const tripApprovalDefinition: IRecordTypeDefinition = {
  ...tripApprovalEntity,
  views: assembleViewSet({
      table: tripApprovalTableView,
      cards: tripApprovalCardsView,
      calendar: tripApprovalCalendarView,
      dashboard: tripApprovalDashboardView,
  }),
  form: tripApprovalFullForm,
  forms: { full: tripApprovalFullForm, context: tripApprovalContextForm, mini: tripApprovalMiniForm, lookup: tripApprovalLookupForm },
  menu: tripApprovalMenu,
} as IRecordTypeDefinition;
